import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { ButtonPrimary } from 'components/Button'
import { LightCard } from 'components/Card'
import Column, { AutoColumn } from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import FiatValue from 'components/FiatValue'
import Loader from 'components/Loader'
import { RowBetween, RowFixed } from 'components/Row'
import ConfirmationTransactionStep, {
  ConfirmationTransactionStepProps,
} from 'components/StepLine/common/ConfirmationTransactionStep'
import { TruncatedText } from 'components/swap/styleds'
import { useContext, useMemo } from 'react'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'

type BaultDepositStepProps = {
  amount: CurrencyAmount<Token> | undefined
  onStake: () => void
  next: () => void
  baultAddress?: string
  apr?: number
} & Omit<ConfirmationTransactionStepProps, 'onConfirm' | 'children'>

const BaultDepositStep = ({
  next,
  onStake,
  amount,
  attemptingTxn,
  baultAddress,
  apr,
  ...rest
}: BaultDepositStepProps) => {
  const theme = useContext(ThemeContext)

  const estimatedCompoundedApr = useMemo(() => {
    if (!apr) return undefined
    // TODO: Add actual calculation
    return apr * 1.2 // 20% // Test value
  }, [apr])

  return (
    <ConfirmationTransactionStep onConfirm={next} attemptingTxn={attemptingTxn} {...rest}>
      <Column width="100%" gap="4px" style={{ marginTop: '12px' }}>
        <LightCard padding="0.75rem 1rem">
          <AutoColumn gap="8px">
            <RowBetween align="center">
              <RowFixed gap="0px">
                <TruncatedText fontSize={24} fontWeight={500}>
                  {amount ? amount?.toExact() : <Loader />}
                </TruncatedText>
              </RowFixed>
              <RowFixed gap="0px">
                <CurrencyLogo currency={amount?.currency} size="20px" style={{ marginRight: '12px' }} />
                <Text fontSize={20} fontWeight={500}>
                  {amount?.currency.symbol}
                </Text>
              </RowFixed>
            </RowBetween>
            <RowBetween>
              <FiatValue currencyAmount={amount} />
            </RowBetween>
          </AutoColumn>
        </LightCard>

        <ButtonPrimary
          style={{ margin: '20px 0 0 0' }}
          onClick={onStake}
          disabled={!amount || attemptingTxn || amount.equalTo('0')}
        >
          <Text fontWeight={500} fontSize={20}>
            <>Confirm Deposit</>
          </Text>
        </ButtonPrimary>
      </Column>
    </ConfirmationTransactionStep>
  )
}

export default BaultDepositStep
